import { createAction } from 'typesafe-actions';

import { PANORAMA_STEP_MODES } from '../../constants/game';

export type PanoramaStepMode = keyof typeof PANORAMA_STEP_MODES;

export const setPanoramaStepMode = createAction(
    '@settings/SET_PANORAMA_STEP_MODE',
    (mode: PanoramaStepMode) => mode,
)();
